<template>
  <tile :icon="headerImg" :link="link">
    <template slot="title">
      <p class="is-size-4 tile-highlight">{{ title }}</p>
    </template>
    <slot name="top"></slot>
    <div v-if="values.length > 0" class="level info">
      <svgicon
        v-if="img"
        class="level-item static125 tile-icon"
        :name="img"
        :width="imgSize"
        :height="imgSize"
        :style="`flex: 0 0 ${imgSize}`"
        :original="imgOriginal">
      </svgicon>
      <div class="level-item shrink">
        <vertical-key-value :values="values">
          <slot name="keyValue"></slot>
        </vertical-key-value>
      </div>
      <slot></slot>
    </div>
    <slot name="bottom"></slot>
  </tile>
</template>

<script>
import Tile from '@/components/Tile.vue';
import VerticalKeyValue from '@/components/VerticalKeyValue.vue';

export default {
  name: 'TileBasic',
  components: { Tile, VerticalKeyValue },
  props: {
    values: {
      type: Array,
      default: () => [],
    },
    link: {
      type: Object,
      requred: true,
    },
    headerImg: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      requred: true,
    },
    img: {
      type: String,
      default: null,
    },
    imgSize: {
      type: String,
      default: '125px',
    },
    imgOriginal: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>

.shrink {
  flex-shrink: 1;
}

.fill {
  width: 100%;
}

.grow {
  flex-grow: 1;
}

.info {
  padding: 1rem;
  margin-bottom: 0;
}
</style>
